// #region imports

// --- Angular
import { HttpClient } from "@angular/common/http";

// --- RxJs
import { Observable, Subject } from "rxjs";

// --- 3rd Party
import { TranslateService } from "@ngx-translate/core";

// --- HS Code
import { AppService } from "..";

// #endregion

export abstract class RemoteCommand {

  protected readonly _COMMAND_STATE_NOT_EXECUTED: string = "not-executed";
  protected readonly _COMMAND_STATE_EXECUTING: string = "executing";
  protected readonly _COMMAND_STATE_EXECUTED: string = "executed";
  protected readonly _COMMAND_STATE_ERROR: string = 'error';

  protected _executionStatus: string = this._COMMAND_STATE_NOT_EXECUTED;

  constructor(
    protected _appService: AppService,
    protected _httpClient: HttpClient,
    protected _translateService: TranslateService
  ) {}

  abstract execute(): void;
  abstract undo(): void;
}

export abstract class RemoteCommandOfT<T> extends RemoteCommand {

  protected static _commandId: number = 0;

  protected _commandResult$: Subject<T> = new Subject<T>();
  get commandResult$(): Observable<T> {
    return this._commandResult$.asObservable();
  };

  constructor(
    _appService: AppService,
    _httpClient: HttpClient,
    _translateService: TranslateService
  ) {
    super(_appService, _httpClient, _translateService);
  }

}
